import { render, staticRenderFns } from "./ReporteGeneral.vue?vue&type=template&id=2dfb5150&"
import script from "./ReporteGeneral.vue?vue&type=script&lang=js&"
export * from "./ReporteGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports